var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dm_detail_card"},[_c('div',{staticClass:"fenshen_title"},[_vm._v(_vm._s(_vm.detail.title || ''))]),_c('div',{staticClass:"video"},[_c('video',{staticClass:"video__inner",attrs:{"src":_vm.videoUrl,"controls":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }